import { Link } from 'gatsby';
import styled from '@emotion/styled';

const Button = styled(Link)`
  top: 0;
  left: 0;
  transition: all 0.15s linear 0s;
  position: relative;
  display: inline-block;
  padding: 15px 25px;
  background-color: var(--success);
  text-transform: lowercase;
  color: var(--text);
  font-family: arial;
  letter-spacing: 1px;
  box-shadow: -6px 6px 0 var(--darkWhite);
  text-decoration: none;

  :hover {
    top: 3px;
    left: -3px;
    box-shadow: -3px 3px 0 var(--darkWhite);

    :before {
      bottom: -2px;
      right: 1px;
      width: 4px;
      height: 4px;
    }

    :after {
      top: 1px;
      left: -2px;
      width: 4px;
      height: 4px;
    }
  }

  :after {
    transition: all 0.15s linear 0s;
    content: '';
    position: absolute;
    top: 2px;
    left: -4px;
    width: 8px;
    height: 8px;
    background-color: var(--darkWhite);
    transform: rotate(45deg);
    z-index: -1;
  }

  :before {
    transition: all 0.15s linear 0s;
    content: '';
    position: absolute;
    bottom: -4px;
    right: 2px;
    width: 8px;
    height: 8px;
    background-color: var(--darkWhite);
    transform: rotate(45deg);
    z-index: -1;
  }

  :active {
    top: 6px;
    left: -6px;
    box-shadow: none;

    :before {
      bottom: 1px;
      right: 1px;
    }
  }
  
  a:active:after {
    top: 1px;
    left: 1px;
  }
`;

const FormButton = styled.button`
  color: var(--text);
  background-color: var(--success);
  border-color: var(--success);
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  width: auto;
  transition: color 0.13s ease-out, background 0.13s ease-out;

  :hover {
    background-color: var(--hoverSuccess);
    cursor: pointer;
  }

  :disabled {
    cursor: default;
    background-color: var(--darkSuccess);
  }
`;

const PrimaryButton = styled(Link)`
  color: var(--text);
  background-color: var(--blue);
  border-color: var(--blue);
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  width: auto;
  max-height: 40px;
  transition: color 0.13s ease-out, background 0.13s ease-out;

  :hover {
    background-color: var(--darkerBlue);
    cursor: pointer;
  }

  :disabled {
    cursor: default;
  }
`;

export { Button, FormButton, PrimaryButton };
